<!-- <nav class="erp-menu" [class.collapsed]="isCollapsed">
  <button class="toggle-btn" (click)="toggleMenu()">
    <mat-icon>{{ isCollapsed ? 'menu_open' : 'menu' }}</mat-icon>
  </button>
  <ul>   
    <li (click)="goToDashboard()">
      <mat-icon>dashboard</mat-icon>
      <span *ngIf="!isCollapsed">Dashboard</span>
    </li>   
    <li (click)="goToChangePassword()">
      <mat-icon>lock_reset</mat-icon>
      <span *ngIf="!isCollapsed">Change Password</span>
    </li>  
    <li (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span *ngIf="!isCollapsed">Logout</span>
    </li>
  </ul>
</nav> -->

<nav class="erp-menu" [class.collapsed]="isCollapsed">
  <button class="toggle-btn" (click)="toggleMenu()">
    <mat-icon>{{ isCollapsed ? 'menu_open' : 'menu' }}</mat-icon>
  </button>

  <ul>
    <!-- Dashboard -->
    <li (click)="goToDashboard()">
      <mat-icon>dashboard</mat-icon>
      <span *ngIf="!isCollapsed">Dashboard</span>
    </li>

     <li (click)="goToApplyLeave()" *ngIf="userType === 'Employee'">
      <mat-icon>note_alt</mat-icon>
      <span *ngIf="!isCollapsed">Apply Leave</span>
    </li>

     <li (click)="goToLeaveRequest()" *ngIf="userType === 'Employee'">
      <mat-icon>calendar_month</mat-icon>
      <span *ngIf="!isCollapsed">Leave Status</span>
    </li>

   <li (click)="goToSalaryAdvanceRequest()" *ngIf="userType === 'Employee'">
      <mat-icon>request_quote</mat-icon>
      <span *ngIf="!isCollapsed">Apply Salary Advance</span>
    </li>

     <li (click)="goToAdvanceSalaryStatus()" *ngIf="userType === 'Employee'">
      <mat-icon>paid</mat-icon>
      <span *ngIf="!isCollapsed">Advance Salary Status</span>
    </li>

      <li (click)="goToApplyLoan()" *ngIf="userType === 'Employee'">
      <mat-icon>request_quote</mat-icon>
      <span *ngIf="!isCollapsed">Apply Loan</span>
    </li>

     <li (click)="goToLoanRequestStatus()" *ngIf="userType === 'Employee'">
      <mat-icon>paid</mat-icon>
      <span *ngIf="!isCollapsed">Loan Request Status</span>
    </li>

     <!-- Outstanding Report -->
    <li (click)="goToOutstandingReport()" *ngIf="userType === 'Vendor'">
      <mat-icon>description</mat-icon>
      <span *ngIf="!isCollapsed">Outstanding Report</span>
    </li>

    <!-- Change Password -->
    <li (click)="goToChangePassword()">
      <mat-icon>lock_reset</mat-icon>
      <span *ngIf="!isCollapsed">Change Password</span>
    </li>

    <!-- Logout -->
    <li (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span *ngIf="!isCollapsed">Logout</span>
    </li>
  </ul>
</nav>

